import { rest } from "msw";
import {
  CommitUploadResponse,
  CommitUploadResponseItem,
  DocumentsListResponse,
  EdmDocumentInfo,
} from "../utility/types/common";
import { EDM_DOC_TYPE, EDM_UPLOAD_STATUS } from "../utility/enums/common";

export const handlers = [
  // ============  apiSlice endpoints - GET ==============//
  rest.get(`/api/getAppConfig/getASHConfig`, (req, res, ctx) => {
    return res(ctx.json("getASHConfig"), ctx.delay(150));
  }),
  rest.get(`/api/jobcontainer/schedule/applicationId/locale`, (req, res, ctx) => {
    return res(ctx.json("useGetJobScheduleDetailQuery"), ctx.delay(150));
  }),
  rest.get(`/api/salesforce/jobdetails/applicationId/locale`, (req, res, ctx) => {
    return res(ctx.json("useGetSalesforceJobDetailQuery"), ctx.delay(150));
  }),
  rest.get(`/api/nhe/appointment/applicationId`, (req, res, ctx) => {
    return res(ctx.json("useGetNHEAppointmentQuery"), ctx.delay(150));
  }),
  rest.get(`/api/sda/applicationId/locale`, (req, res, ctx) => {
    return res(ctx.json("useGetStartDateInfoQuery"), ctx.delay(150));
  }),
  rest.get(`/api/application/application-manage-data/applicationId/locale`, (req, res, ctx) => {
    return res(ctx.json("useGetApplicationManageDataQuery"), ctx.delay(150));
  }),
  rest.get(`/api/salesforce/application-manage-data/applicationId`, (req, res, ctx) => {
    return res(ctx.json("useGetApplicationManagementDataFromSFQuery"), ctx.delay(150));
  }),
  rest.get(`api/cds/candidate/applicationId`, (req, res, ctx) => {
    return res(ctx.json("useGetCandidateDataQuery"), ctx.delay(150));
  }),
  rest.get(`/api/atoz/candidateGlobalId/applicationId/locale/returnResetPasswordUrl`, (req, res, ctx) => {
    return res(ctx.json("useGetCandidateAtoZStatusQuery"), ctx.delay(150));
  }),
  rest.get(`/api/document-status/candidateGlobalId/applicationId/locale/Salesforce/False`, (req, res, ctx) => {
    return res(ctx.json("useGetDocumentStatusInfoQuery"), ctx.delay(150));
  }),
  rest.get(`/api/edm/documentUpload/bbCandidateId/applicationId`, (req, res, ctx) => {
    return res(ctx.json("useGetDocumentsWidgetsQuery"), ctx.delay(150));
  }),
  // ============  apiSlice endpoints - POST ==============//
  rest.post(`/api/withdraw-application/applicationId`, (req, res, ctx) => {
    return res(
      // Respond with a 200 status code
      ctx.status(200),
      ctx.json("useWithDrawApplicationMutation")
    );
  }),
  rest.post(`/api/edm/commitUpload/candidateGlobalId/applicationId`, (req, res, ctx) => {
    return res(
      // Respond with a 200 status code
      ctx.status(200),
      ctx.json("useCommitDocumentsMutation")
    );
  }),
];

// browserHandlers are responsible for mocking api request in browser for development purpose, remove when we want to get data from real API instead. -- Use absolute URL for the endpoints.
export const browserHandlers = [
  rest.get("http://localhost:9000/checklist/api/edm/documentUpload/bbCandidateId/applicationId", (req, res, ctx) => {
    return res(
      ctx.json({
        documents: [
          {
            document_type_id: "LICENSE",
            document_id: "file_1_id",
            draft_id: "draft_id_server_1",
            created_at: new Date("2021-01-01T00:00:00.000Z"),
            upload_status: "SUCCEEDED",
            review_status: "Approved",
            files: {
              fileName: "file1",
              contentSize: "1mb",
              contentType: "JPG",
            },
          },
          {
            document_type_id: "PASSPORT",
            document_id: "file_2_id",
            draft_id: "draft_id_server_2",
            created_at: new Date("2021-01-01T00:00:00.000Z"),
            review_status: "Reject Manually Uploaded",
            upload_status: "SUCCEEDED",
            files: {
              fileName: "file2",
              contentSize: "1TB",
              contentType: "PDF",
            },
          },
        ] as EdmDocumentInfo[],
      } as DocumentsListResponse),
      ctx.delay(150)
    );
  }),
  rest.post(`http://localhost:9000/checklist/api/edm/commitUpload/candidateGlobalId/applicationId`, (req, res, ctx) => {
    return res(
      // Respond with a 200 status code
      ctx.status(200),
      ctx.json({
        commitStatuses: [
          {
            document_type_id: EDM_DOC_TYPE.BIRTH_CERTIFICATE,
            document_id: "document_id",
            draft_id: "draft_id",
            status: EDM_UPLOAD_STATUS.PENDING,
          },
        ] as CommitUploadResponseItem[],
      } as CommitUploadResponse)
    );
  }),
];
